import React from 'react';

import { default as MaterialButton } from '@mui/material/Button';
import cx from 'classnames';

import SafeLink from '../../../blocks/Header/components/SafeLink/SafeLink';
import useStyles from './styles';

const Button = ({ text = '', link = '#', isPrimary = true, className = '', ...rest }) => {
  const classes = useStyles(isPrimary)();

  return (
    <MaterialButton
      variant="contained"
      className={cx(classes.button, className)}
      data-testid={rest['data-testid']}
    >
      <SafeLink to={link}>{text}</SafeLink>
    </MaterialButton>
  );
};

export default Button;
